import { render, staticRenderFns } from "./AfaAntropometriciViewComponent.vue?vue&type=template&id=3ef12a82"
import script from "./AfaAntropometriciViewComponent.vue?vue&type=script&lang=js"
export * from "./AfaAntropometriciViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports